import { Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatAutocompleteTrigger, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { CustomerService } from 'src/app/customer/customer.service';
import { PopupService } from 'src/app/popup/popup.service';
import { QuotesDataModel } from 'src/app/quotes/quotes-data-model';
import { ContactFormDialogComponent } from 'src/app/shared/add-contact/contact-form-dialog/contact-form-dialog.component';
import { ContactDetailsPopupComponent } from 'src/app/shared/contact-details-popup/contact-details-popup.component';
import { CustomerDetailsPopupComponent } from 'src/app/shared/customer-details-popup/customer-details-popup.component';
import { CustomerEditFormPopupComponent } from 'src/app/shared/customer-edit-form-popup/customer-edit-form-popup.component';
import { LeadAccountAddFormComponent } from 'src/app/shared/lead-account-add-form/lead-account-add-form.component';
import { LeadAccountDetailsPopupComponent } from 'src/app/shared/lead-account-details-popup/lead-account-details-popup.component';
import { LeadEditFormPopupComponent } from 'src/app/shared/lead-edit-form-popup/lead-edit-form-popup.component';
import { AccountTypeEnum } from '../app-common-enum';

@Component({
    selector: 'app-account-form',
    templateUrl: './orders-account-form.component.html',
    styleUrls: ['./orders-account-form.component.scss']
})
export class OrdersAccountFormComponent implements OnInit {

    @ViewChild('matAccountAutocomplete', { read: MatAutocompleteTrigger, static: false }) autoComplete: MatAutocompleteTrigger;
    @ViewChild('matContactAutocomplete', { read: MatAutocompleteTrigger, static: false }) matContactAutocomplete: MatAutocompleteTrigger;
    @ViewChild('accountForm', { static: true }) accountForm: NgForm;
    @Output() emitAccountInformation: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitContactInformation: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitOrderStatusFromAccountInformation: EventEmitter<any> = new EventEmitter<any>();
    @Input() isUpdate: boolean;
    @Input() isJobForm: boolean;
    @Input() isJobFromCustomer: boolean;
    @Input() readOnly: boolean;
    @Input() set accountDetailsParam(accountDetailsParam: any) {
        if (accountDetailsParam && accountDetailsParam.account.accountId) {
            this.orderDetails = accountDetailsParam;
            this.assignedTo = this.orderDetails.assignedTo;
            this.accountDetails = this.orderDetails.account;
            this.account = [];
            this.accountContactList = [];
            this.setOrderType();
            this.isUpdateOnload = true;
            if (this.accountDetails && this.accountDetails.contactId) {
                this.tempAccountDetails = { ...this.accountDetails };
            }

            if (this.isJobFromCustomer) {
                this.isSetPrimaryContact = true;
                this.onChangeContact(null, false);
            }
            this.getpopupNotification(accountDetailsParam.account.accountId);
            this.commonMethod.sendAutoPopulateAccountId(accountDetailsParam.account.accountId);
        } else {
            this.commonMethod.sendAutoPopulateAccountId(0);
        }
    };
    @Input() set accountDetailsObjectWhileRFQ(accountDetailsParam: any) {
        if (accountDetailsParam && accountDetailsParam.accountId) {
            this.accountDetails.accountTypeId = accountDetailsParam.accountTypeId;
            this.accountDetails.isAccountChanged = true;
            this.isSetPrimaryContact = true;
            this.onChangeContact(null, false);
            this.commonMethod.sendAutoPopulateAccountId(accountDetailsParam.accountId);
        } else {
            this.commonMethod.sendAutoPopulateAccountId(0);
        }
    };
    accountTypeEnum: typeof AccountTypeEnum = AccountTypeEnum;
    quotesDataModel = new QuotesDataModel();
    quoteRequestModel = this.quotesDataModel.quotePostModel;
    shippingDetails = this.quotesDataModel.shippingDetailsModel;
    accountDetails = this.quotesDataModel.accountDetails;
    orderDetails: any;
    accounts: any = [];
    leadName: string;
    account: any;
    accountContactList: any;
    isChangePrimaryAccountContact = true;
    isNewAccountContact = false;
    assignedTo: any;
    isFormLoading = false;
    contactLongId: number;
    isAccountBinded = false;
    primaryContact: any;
    isSetPrimaryContact = false;
    orderType: string;
    tempAccountDetails: any;
    isUpdateOnload = false;

    isDeletedContact = false;

    isAccountLoading = false;
    isAccountContactLoading = false;
    isUpdateFromAccountDetails = false;
    contactInfoToBeEmit = {
        isContactDeleted: false,
        isParticipantsConfigure: true,
        previousAccountId: 0
    }
    commonConstants: typeof CommonConstants = CommonConstants;

    constructor(
        private commonService: CommonService,
        private dialog: MatDialog,
        private accountService: CustomerService,
        private popupService: PopupService,
        private contactService: ContactService,
        private commonMethod: CommonMethod,
        private router: Router,
        private customerService: CustomerService,
        private renderer: Renderer2
    ) { }

    ngOnInit() {
        window.addEventListener('scroll', this.autoCompleteScrollEvent, true);
        this.setOrderType();
        if (!this.isUpdate) {
            this.onChangeAccount('');
        }
        this.commonMethod.sendTabName(this.orderType);
    }

    setOrderType() {
        if (this.router.url.indexOf('/jobs') !== -1) {
            this.orderType = 'Job';
        } else if (this.router.url.indexOf('/quotes') !== -1) {
            if (this.router.url.indexOf('/quick-quote-form') !== -1) {
                this.orderType = 'Quick Quote';
            } else {
                this.orderType = (this.orderDetails && this.orderDetails.isQuickQuote) ? 'Quick Quote' : 'Quote';
            }
        }
    }

    onSelectAcountName(value: any) {
        this.isChangePrimaryAccountContact = true;
    }

    onSelectContactName(value: any) {
        this.accountDetails.contactName = value ? value.fullName : '';
    }

    onChangeAccount(searchText: string, forNewAccount?: boolean): void {
        this.accounts = [];
        this.isAccountLoading = true;
        this.commonService.getAccounts(searchText).subscribe(response => {
            this.isAccountLoading = false;
            if (forNewAccount) {
                this.onChangeContact(null, false);
            }
            if (!this.accountDetails.accountName && !searchText) {
                this.accountForm.form.markAsDirty();
                this.accountDetails.accountName = '';
                this.accountDetails.accountId = null;
                this.accountDetails.contactName = '';
                this.accountDetails.contactId = null;
                this.emitAccountInformation.emit();
            }
            this.accounts = response.data;
        });
    }

    onChangeContact(searchQuery?: any, forNewAccount?: boolean): void {
        this.accountContactList = [];
        let queryString = `PrimaryAccountId=${this.accountDetails.accountId}`;
        queryString += searchQuery ? `&SearchQuery=${searchQuery}` : '';
        this.isAccountContactLoading = true;
        this.contactService.getContacts(queryString).subscribe(response => {
            this.isAccountContactLoading = false;
            if (response.isSuccess) {
                this.accountContactList = response.data;
                if (this.isUpdateOnload) {
                    const primaryContact = this.accountContactList.filter(item => item.isPrimaryContact === true)[0];
                    this.primaryContact = primaryContact;
                    this.isUpdateOnload = false;
                }
                if (this.isSetPrimaryContact && !this.isUpdateOnload) {
                    const selectedContact = this.accountContactList.filter(item => item.contactId === this.accountDetails.contactId)[0];
                    const primaryContact = this.accountContactList.filter(item => item.isPrimaryContact === true)[0];
                    this.primaryContact = primaryContact;
                    this.isChangePrimaryAccountContact = true;
                    this.setPrimaryAccountContact(selectedContact);
                    this.isSetPrimaryContact = false;
                    this.accountContactList = [];
                }
                if (forNewAccount) {
                    this.matContactAutocomplete.openPanel();
                }
                if (this.isNewAccountContact) {
                    this.isNewAccountContact = false;
                }
            }
        });
    }

    setPrimaryAccountContact(selectedContact: any) {
        if (this.isChangePrimaryAccountContact) {
            this.onSetContactDetails(selectedContact);
            this.onSelectContactName(selectedContact);
            this.isChangePrimaryAccountContact = false;
        }
    }

    getLeadAccountDetails(accountId: string): void {
        this.accountService.getAccount(accountId).subscribe(response => {
            if (response.isSuccess) {
                this.accountDetails.accountId = response.data.id;
                this.accountDetails.accountTypeId = this.accountTypeEnum.lead;
                this.accountDetails.accountName = response.data.accountName;
                this.accountDetails.contactId = response.data.contactId;
                this.isSetPrimaryContact = true;
                this.onChangeContact('', false);
                this.accountContactList = [];
                this.autoComplete.closePanel();
                this.emitAccountInformation.emit();
            }
        });
    }

    getContactDetails(contactId: string): void {
        this.contactService.editContact(contactId).subscribe(response => {
            if (response.isSuccess) {
                this.accountDetails.contactName = response.data.firstName;
                this.onChangeContact('', false);
                this.onSetContactDetails(response.data);
            }
        });
    }

    onSetAccountDetails(account: any, inputElement: HTMLInputElement): void {
        if (account && account.accountId) {
            this.contactInfoToBeEmit.previousAccountId = this.accountDetails.accountId;
            this.accountDetails.contactId = null;
            this.accountDetails.contactName = null;
            this.accountDetails.isAccountChanged = account.accountId !== this.accountDetails.accountId;
            this.commonService.objectMapping(this.accountDetails, account);
            this.accountDetails.accountTypeId = account.suffix === '(CUS)' ? 2 : 1;
            this.contactInfoToBeEmit.isParticipantsConfigure = account.isParticipantsConfigure;
            this.isSetPrimaryContact = true;
            this.accountForm.form.markAsDirty();
            this.onChangeContact(null, false);
            this.getpopupNotification(account.accountId);
            this.commonMethod.sendAutoPopulateAccountId(account.accountId);
            setTimeout(() => inputElement.blur(), 0);
        } else {
            this.commonMethod.sendAutoPopulateAccountId(0);
        }
    }

    getpopupNotification(customerId: any) {
        this.popupService.getPopupListForAccount(customerId).subscribe(popupListResponse => {
            if (popupListResponse.data && popupListResponse.data.length > 0) {
                popupListResponse.data.forEach(item => {
                    this.commonService.getMessagePopup
                        (item.message, item.expiringOnId == 1 ? true : false).then(result => {
                            if (result) {
                                if (item.expiringOnId == 1) {
                                    this.popupService.updatePopupStatus({ popupId: item.id }).subscribe(updatePopupResponse => {


                                    });
                                }
                            }
                            if (this.autoComplete && this.autoComplete.panelOpen) {
                                this.autoComplete.closePanel();
                            }
                        });
                });
            }
        });
    }

    onSetContactDetails(contact: any): void {
        if (contact && contact.contactId) {
            this.accountDetails.contactId = contact.contactId;
            this.accountDetails.contactName = contact.fullName;
            this.accountForm.form.markAsDirty();
            this.contactInfoToBeEmit.isContactDeleted = true;
            this.emitContactInformation.emit(this.contactInfoToBeEmit);
            this.tempAccountDetails = { ...this.accountDetails };
        }
    }

    onOpenAccountDetails(): void {
        if (this.accountDetails.accountTypeId === 2) {
            this.dialog
                .open(CustomerDetailsPopupComponent, {
                    position: {
                        top: '60px',
                        left: '60px'
                    },
                    height: '92%',
                    panelClass: ['small_layout', 'details_layout'],
                    hasBackdrop: false,
                    autoFocus: false,
                    data: { customerId: this.accountDetails.accountId }
                }).afterClosed()
                .subscribe((response: any) => {
                    if (response.success) {
                        this.isUpdateFromAccountDetails = true;
                        const account = {
                            accountId: response.data.id,
                            accountName: response.data.accountName,
                            contactId: response.data.contactId,
                            contactName: '',
                            displayId: response.data.accountDisplayId,
                            suffix: '(CUS)'
                        };
                        this.accountDetails.contactId = null;
                        this.accountDetails.contactName = null;
                        this.commonService.objectMapping(this.accountDetails, account);
                        this.accountDetails.accountTypeId = account.suffix === '(CUS)' ? 2 : 1;
                        this.isSetPrimaryContact = true;
                        this.accountForm.form.markAsDirty();
                        this.onChangeContact(null, false);
                        this.getpopupNotification(account.accountId);
                    }
                });
        } else {
            this.dialog
                .open(LeadAccountDetailsPopupComponent, {
                    position: {
                        top: '60px',
                        left: '60px'
                    },
                    height: '92%',
                    panelClass: ['small_layout', 'details_layout'],
                    hasBackdrop: false,
                    autoFocus: false,
                    data: { leadId: this.accountDetails.accountId }
                }).afterClosed()
                .subscribe((response: any) => {
                    if (response.success) {
                        this.isUpdateFromAccountDetails = true;
                        const account = {
                            accountId: response.data.id,
                            accountName: response.data.accountName,
                            contactId: response.data.contactId,
                            contactName: '',
                            displayId: response.data.accountDisplayId,
                        };
                        this.accountDetails.contactId = null;
                        this.accountDetails.contactName = null;
                        this.commonService.objectMapping(this.accountDetails, account);
                        this.accountDetails.accountTypeId = 1;
                        this.isSetPrimaryContact = true;
                        this.accountForm.form.markAsDirty();
                        this.onChangeContact(null, false);
                        this.getpopupNotification(account.accountId);
                    }
                });
        }
    }

    onOpenContactDetails(): void {
        this.dialog
            .open(ContactDetailsPopupComponent, {
                position: {
                    top: '60px',
                    left: '60px'
                },
                panelClass: ['small_layout', 'details_layout'],
                hasBackdrop: false,
                autoFocus: false,
                data: { contactId: this.accountDetails.contactId }
            }).afterClosed()
            .subscribe((response: any) => {
                if (response.success) {
                    this.isUpdateFromAccountDetails = true;
                    const createContactObj = {
                        contactId: response.contactLongId,
                        displayId: response.response.contactDisplayId,
                        emailOrPhone: response.response.email,
                        fullName: response.response.contactName,
                        isPrimaryContact: null
                    };
                    this.onSetContactDetails(createContactObj);
                }
            });
    }

    onOpenForm(): void {
        this.dialog
            .open(LeadAccountAddFormComponent, {
                position: {
                    right: '0',
                },
                panelClass: 'small_layout',
                hasBackdrop: false,
                autoFocus: false,
                data: { isQuickAccount: false }
            }).afterClosed()
            .subscribe((response: any) => {
                if (response) {
                    this.getLeadAccountDetails(response.leadId);
                    // this.emitAccountInformation.emit();
                } else {
                    if (this.tempAccountDetails.accountId) {
                        this.accountDetails.accountName = this.tempAccountDetails.accountName;
                    } else {
                        this.onChangeAccount('');
                    }
                }
            });
    }

    onClearAccountSelected(event?: any) {
        if (event) {
            event.stopImmediatePropagation();
        }
        this.commonService.getConfirmationPopup(`You want to remove Account?
      ${this.orderType}.`).then(result => {
            if (result) {
                this.accountForm.form.markAsDirty();
                this.accountDetails.accountName = '';
                this.accountDetails.accountId = null;
                this.accountDetails.contactName = '';
                this.accountDetails.contactId = null;
                this.contactLongId = null;
                this.isChangePrimaryAccountContact = true;
                this.contactInfoToBeEmit.isParticipantsConfigure = true;
                this.onChangeAccount('');
                this.emitAccountInformation.emit(true);
            }
        });
    }

    onClearContactSelected(event?: any) {
        if (event) {
            event.stopImmediatePropagation();
        }
        this.commonService.getConfirmationPopup(`You want to remove Contact Details ?`).then(result => {
            if (result) {
                this.accountForm.form.markAsDirty();
                this.accountDetails.contactName = '';
                this.accountDetails.contactId = null;
                this.contactLongId = null;
                this.onChangeContact(null, null);
                this.isDeletedContact = true;
                this.contactInfoToBeEmit.isContactDeleted = true;
                this.emitContactInformation.emit(this.contactInfoToBeEmit);
            }
        });
    }

    onOpenAddAddressDialog(): void {
        this.dialog.open(ContactFormDialogComponent, {
            position: {
                right: '0',
            },
            panelClass: 'small_layout',
            hasBackdrop: false,
            data: {
                accountName: this.accountDetails.accountName,
                accountId: this.accountDetails.accountId,
                accountTypeId: this.accountDetails.accountTypeId,
            },
        }).afterClosed()
            .subscribe((response: any) => {
                if (response) {
                    this.isNewAccountContact = true;
                    this.accountDetails.contactName = response.data.fullName;
                    this.onSetContactDetails(response.data);
                    this.onChangeContact(response.data.fullName);
                } else {
                    this.accountDetails.contactName = this.tempAccountDetails.contactName;
                }
            });
    }

    onClickPrimaryContact(addressType: string) {
        this.commonMethod.setAddressFromAccount.next(addressType);
    }

    onEditAccount() {
        this.isFormLoading = true;
        this.customerService.getAccount(this.accountDetails.accountId).subscribe(resp => {
            this.isFormLoading = false;
            const customerDetails = resp.data;
            if (this.accountDetails.accountTypeId === 2) {
                this.dialog.open(CustomerEditFormPopupComponent, {
                    position: {
                        top: '60px',
                        left: '60px'
                    },
                    panelClass: ['small_layout', 'details_layout'],
                    hasBackdrop: false,
                    autoFocus: false,
                    data: { accountId: customerDetails.accountId }
                }).afterClosed()
                    .subscribe((response: any) => {
                        this.isUpdateFromAccountDetails = true;
                        if (response && response.data) {
                            const account = {
                                accountId: response.data.id,
                                accountName: response.data.accountName,
                                contactId: response.data.contact.contactId,
                                contactName: '',
                                displayId: response.data.accountDisplayId,
                                suffix: '(CUS)'
                            };
                            this.accountDetails.contactId = null;
                            this.accountDetails.contactName = null;
                            this.commonService.objectMapping(this.accountDetails, account);
                            this.accountDetails.accountTypeId = account.suffix === '(CUS)' ? 2 : 1;
                            this.isSetPrimaryContact = true;
                            this.accountForm.form.markAsDirty();
                            this.onChangeContact(null, false);
                            this.getpopupNotification(account.accountId);
                        }
                    });
            } else {
                this.dialog.open(LeadEditFormPopupComponent, {
                    position: {
                        top: '60px',
                        left: '60px'
                    },
                    panelClass: ['small_layout', 'details_layout'],
                    hasBackdrop: false,
                    autoFocus: false,
                    data: { accountId: customerDetails.accountId }
                }).afterClosed()
                    .subscribe((response: any) => {
                        if (response.success) {
                            this.isUpdateFromAccountDetails = true;
                            const account = {
                                accountId: response.data.id,
                                accountName: response.data.accountName,
                                contactId: response.data.contact.contactId,
                                contactName: '',
                                displayId: response.data.accountDisplayId,
                                // suffix: '(CUS)'
                            };
                            this.accountDetails.contactId = null;
                            this.accountDetails.contactName = null;
                            this.commonService.objectMapping(this.accountDetails, account);
                            this.accountDetails.accountTypeId = 1;
                            this.isSetPrimaryContact = true;
                            this.accountForm.form.markAsDirty();
                            this.onChangeContact(null, false);
                            this.getpopupNotification(account.accountId);
                        }

                    });
            }

        });
    }

    onEditContact() {
        this.isFormLoading = true;
        this.contactService.getRecord(this.accountDetails.contactId)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe((resp: any) => {
                const contactDetails = resp.data;
                this.isFormLoading = false;
                this.dialog.open(ContactFormDialogComponent, {
                    position: {
                        right: '0',
                    },
                    panelClass: 'small_layout',
                    hasBackdrop: false,
                    data: {
                        contactId: contactDetails.contactId,
                        isEdit: true,
                        accountName: contactDetails.associatedAccountName,
                        accountId: contactDetails.accountPrimaryId,
                        accountTypeId: contactDetails.accountTypeId
                    },
                })
                    .afterClosed()
                    .subscribe((response: any) => {
                        if (response) {
                            this.isFormLoading = true;
                            this.isUpdateFromAccountDetails = true;
                            this.contactService.getRecord(this.accountDetails.contactId)
                                .pipe(finalize(() => (this.isFormLoading = false)))
                                .subscribe(contactResp => {
                                    const contactDetailsResponse = contactResp.data;
                                    this.isFormLoading = false;
                                    if (contactResp.isSuccess) {
                                        const createContactObj = {
                                            contactId: this.accountDetails.contactId,
                                            displayId: contactDetailsResponse.contactDisplayId,
                                            emailOrPhone: contactDetailsResponse.email,
                                            fullName: contactDetailsResponse.contactName,
                                            isPrimaryContact: null
                                        };
                                        this.onSetContactDetails(createContactObj);
                                    }
                                });
                        }
                    });
            });
    }


    autoCompleteScrollEvent = (event: any): void => {
        if (event.target && event.target.className && event.target.className.indexOf('mat-autocomplete-visible') === -1) {
            if (this.autoComplete && this.autoComplete.panelOpen) {
                this.autoComplete.closePanel();
            } else if (this.matContactAutocomplete && this.matContactAutocomplete.panelOpen) {
                this.matContactAutocomplete.closePanel();
            }
        }
    }

    onOpenAccountOption() {
        this.autoComplete.openPanel();
    }

    onOpenContactOption() {
        this.matContactAutocomplete.openPanel();
    }

}
